import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { alignEntity } from 'actions/livefeed'
const AlignButton = (props) => {
    const { currentEntity, dispatch } = props;

    const activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
    const isAbleToAlign = currentEntity && (
        currentEntity.id !== null && (
            activeToolbarItems[2].isText || currentEntity.id === "line" ||
            currentEntity.id === "logo" || currentEntity.id === "gauge0" || currentEntity.id === "gauge1"
            || currentEntity.id === "gauge2"
        ) && currentEntity.id !== "rightPanelGaugeValueLabel"
    );

    function activeAlignClass(item) {
        let classes = 'icon-wrapper justify-center'
        if (currentEntity.id !== null) {
            classes += ` ${activeToolbarItems[0].align === item ? 'icon-wrapper_active' : ''}`
        }
        return classes
    }
    // ------------------------ shortcut key keyHandlerAlign for Aligning functions --------------------
    useEffect(() => {
        const keyHandlerAlign = function (event) {
            // ----------------------- Align keys hanlde ---------------------------
            if (event.ctrlKey && event.key === "l") {
                alignEntityHandle("left")
            } else if (event.ctrlKey && event.key === "e") {
                alignEntityHandle("center")
            }
            else if (event.ctrlKey && event.key === "r") {
                alignEntityHandle("right")
            }
            // for mac
            if (event.metaKey && event.key === "l") {
                alignEntityHandle("left")
            }

            else if (event.metaKey && event.key === "e") {
                alignEntityHandle("center")
            }
            // shortkey for aligning right for mac ?? cmd r will reload page, preventDefault is bad for UX. just let it be :), nobody would use this function at all
        }
        window.addEventListener("keydown", keyHandlerAlign);
        return () => {
            window.removeEventListener("keydown", keyHandlerAlign)
        }
    }, [alignEntityHandle, currentEntity.id, dispatch])

    const alignEntityHandle = useCallback((mode) => {
        currentEntity.id !== null && dispatch(alignEntity(currentEntity.id, mode))
    }, [currentEntity.id, dispatch])

    return (
        <React.Fragment>
            < div onClick={() => isAbleToAlign ? alignEntityHandle("left") : null} className={`${activeAlignClass("left")} ${isAbleToAlign ? '' : 'icon-wrapper_disable'}`} >
                <i data-tooltip={'Align Left'} className="material-icons">&#xe236;</i>
            </div >
            <div onClick={() => isAbleToAlign ? alignEntityHandle("center") : null} className={`${activeAlignClass("center")} ${isAbleToAlign ? '' : 'icon-wrapper_disable'}`} >
                <i data-tooltip={'Align Center'} className="material-icons">&#xe234;</i>
            </div>
            <div onClick={() => isAbleToAlign ? alignEntityHandle("right") : null} className={`${activeAlignClass("right")} ${isAbleToAlign ? '' : 'icon-wrapper_disable'}`} >
                <i data-tooltip={'Align Right'} className="material-icons">&#xe237;</i>
            </div>
        </React.Fragment>
    );
}

AlignButton.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentEntity: PropTypes.object.isRequired
}
export default AlignButton;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/AlignButton.jsx